
function getCloudflareCountry() {
  const match = document.cookie.match(/(?:^|; )cf_country=([^;]+)/);
  return match ? match[1] : null;
}

window.shopifyMarketsCountries = [];
window.currentShopifyCountry = getCloudflareCountry();

document.addEventListener("click", function (e) {
  let countrySelectorLink = e.target.closest('country-selector a');
  if (countrySelectorLink) {
    console.log("🌍 Language switched to:", countrySelectorLink.href);
    document.cookie = "lang_popup_shown=true; path=/; max-age=86400";
  }
});

document.addEventListener("DOMContentLoaded", function () {

  function isBotFromCloudflare() {
    return document.cookie.includes('cf_is_bot=1');
  }

  if (isBotFromCloudflare()) return;

  function getBrowserLang() {
    return (navigator.language || '').toLowerCase().startsWith('it') ? 'it' : 'en';
  }

  function getSiteLang() {
    return (document.documentElement.getAttribute('lang') || 'en').toLowerCase();
  }

  function getTargetCountry() {
    const browserLang = getBrowserLang();
    const siteLang = getSiteLang();
    const validCountries = window.shopifyMarketsCountries || [];
    const currentCountry = window.currentShopifyCountry || '';

    if (siteLang === 'en' && browserLang === 'it') {
      return 'IT';
    }

    if (siteLang === 'it' && browserLang !== 'it') {
      return validCountries.includes(currentCountry) ? currentCountry : 'IE';
    }

    return null;
  }

  setTimeout(function () {
    let interacted = false;
    const onInteract = () => {
      if (interacted) return;
      interacted = true;
      initPopup();
      removeListeners();
    };

    window.addEventListener('mousemove', onInteract);
    window.addEventListener('scroll', onInteract);
    window.addEventListener('touchstart', onInteract);

    setTimeout(removeListeners, 10000);

    function removeListeners() {
      window.removeEventListener('mousemove', onInteract);
      window.removeEventListener('scroll', onInteract);
      window.removeEventListener('touchstart', onInteract);
    }

    function initPopup() {
      if (document.cookie.includes('lang_popup_shown=true')) return;

      const browserLang = getBrowserLang();
      const siteLang = getSiteLang();

      if (browserLang === siteLang) return;

      let texts = {
        it: {
          question: "Parli Italiano?",
          yes: "Sì, cambia lingua",
          no: "No, english is ok"
        },
        en: {
          question: "Flip to English?",
          yes: "Yeah, take me there",
          no: "No, meglio in italiano"
        }
      };

      let popupLang = browserLang === 'it' ? 'it' : 'en';

      let overlay = document.createElement('div');
      overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.6);
    z-index: 9998;
  `;

      let div = document.createElement('div');
      div.innerHTML = `
    <div 
      style="
      position:fixed;
      top:50%;
      left:50%;
      transform:translate(-50%, -50%);
      background:#fff;
      padding:24px;
      z-index:9999;
      box-shadow:0 0 15px rgba(0,0,0,0.3);
      width:500px;
      max-width:90vw;
     
      text-align: center;
    ">
      <button id="langPopupClose" style="
        position: absolute;
        top: 5px;
        right: 8px;
        background: transparent;
        border: none;
        font-size: 20px;
        cursor: pointer;
      ">&times;</button>
      <h4>${texts[popupLang].question}</h4>
      <button class="btn btn--primary w-full" id="langSwitchBtn" style="margin: 24px 0 0;"">${texts[popupLang].yes}</button>
      <br>
      <button class="btn btn--secondary w-full" id="langDismissBtn" style="margin: 24px 0 0;">${texts[popupLang].no}</button>
    </div>
  `;

      document.body.appendChild(overlay);
      document.body.appendChild(div);

      function dismissPopup() {
        document.cookie = "lang_popup_shown=true; path=/; max-age=86400";
        overlay.remove();
        div.remove();
      }

      document.getElementById('langSwitchBtn').addEventListener('click', () => {
        document.cookie = "lang_popup_shown=true; path=/; max-age=86400";

        const targetCountry = getTargetCountry();
        if (targetCountry) {
          let form = document.createElement('form');
          form.method = 'POST';
          form.action = '/localization';
          form.innerHTML = `
        <input type="hidden" name="form_type" value="localization">
        <input type="hidden" name="utf8" value="✓">
        <input type="hidden" name="_method" value="put">
        <input type="hidden" name="return_to" value="${window.location.pathname}${window.location.search}${window.location.hash}">
        <input type="hidden" name="country_code" value="${targetCountry}">
      `;
          document.body.appendChild(form);
          form.submit();
        } else {
          console.log("🌍 Nessun suggerimento valido per cambio country.");
          dismissPopup();
        }
      });

      document.getElementById('langDismissBtn').addEventListener('click', dismissPopup);
      document.getElementById('langPopupClose').addEventListener('click', dismissPopup);
    }


  }, 2000);
});

